import {
  ClosedLine,
  EvolvingLine,
  FilterLine,
  matches as lineMatches,
  Line
} from './line';

export type ClosedStatement = ClosedLine[];
export type FilterStatement = FilterLine[];
export type Statement = Line[];
export type EvolvingStatement = EvolvingLine[];

export const match = (
  lines: EvolvingStatement,
  main: ClosedStatement
): boolean =>
  !(lines.length < main.length) &&
  lines.findIndex(
    (line: EvolvingLine, index: number) =>
      (index >= main.length && line !== undefined) ||
      !lineMatches(line, main[index])
  ) === -1;

export const equal = (
  first: EvolvingStatement,
  second: EvolvingStatement
): boolean => {
  const found = first.findIndex(
    (line: EvolvingLine, index: number) =>
      (index >= second.length && line !== undefined) || line !== second[index]
  );

  return (
    found === -1 &&
    !(second.length > first.length
      ? second
          .slice(first.length)
          .findIndex((line: EvolvingLine) => line !== undefined) !== -1
      : false)
  );
};
